import { useQuery } from '@tanstack/react-query';
import { useState, useCallback } from 'react';
import useHttpClient from './useHttpClient';
import { IProject, IProjectSearchPayload } from './models/project';

export interface IQueryAttachedProjectsHook {
  attachedProjectsResults: IProjectSearchPayload,
  getAttachedProjects: (emailId: string) => void;
}

const useQueryAttachedProjects = (): IQueryAttachedProjectsHook => {
  const httpClient = useHttpClient();
  const [emailId, setEmailId] = useState<string | null>(null);

  const {
    data: attachedProjects,
    error,
    isLoading: loading,
    isFetched: called,
  } = useQuery<IProject[]>({
    queryKey: ['attachedProjects', emailId],
    queryFn: async () => {
      if (!emailId) return [];

      const response = await httpClient.get(`/projects/FindByOutlookEmailId/${emailId}`);
      return response.data || [];
    },
    enabled: !!emailId,
  });

  const getAttachedProjects = useCallback(
    (id: string) => {
      setEmailId(id);
    }, []
  );

  return {
    attachedProjectsResults: {
      called,
      error: error as Error | undefined,
      loading,
      count: attachedProjects?.length || 0,
      items: attachedProjects || [],
      hasMore: false,
    },
    getAttachedProjects,
  };
};

export default useQueryAttachedProjects;
